import plotlyWheelUrl from '../assets/plotly-7.1.0-py3-none-any.whl?url'

/** Installed lazily by the worker on the first cell that imports plotly (not at boot). */
export const PLOTLY_WHEEL_FILENAME = 'plotly-7.1.0-py3-none-any.whl'
export const PLOTLY_VERSION = '7.1.0'
export const PLOTLY_WHEEL_SHA256 = 'dbb7fa18afce40d0a8e80d1bf162eceb3faa0ce5a77fe741ad09a74cf78f53f3'
/** The plotly.js bundled inside PLOTLY_VERSION; served through the same jsDelivr proxy as Pyodide. */
export const PLOTLY_JS_PATH = 'npm/plotly.js-dist-min@4.1.1/plotly.min.js'

export { plotlyWheelUrl }
